import CustomBottom from "../../components/CustomBottom";
import CustomHeader from "../../components/CustomHeader";
import React from "react";

export default function DesignShop() {
  const fileDownload = [
    { link: "/img/F-Design01.png" },
    { link: "/img/F-Design02.png" },
    { link: "/img/F-Design03.png" },
    { link: "/img/F-Design04.png" },
    { link: "/img/F-Design05.png" },
    { link: "/img/F-Design07.jpg" },
    { link: "/img/F-Design08.png" },
    { link: "/img/F-Design09.jpg" },
    { link: "/img/F-Design10.jpg" },
    { link: "/img/F-Design11.jpg" },
    { link: "/img/F-Design13.jpg" },
    // { link: "/img/F-Design06.png" },
  ];
  return (
    <div className="fade_In">
      <CustomHeader />

      <div className="flex flex-row items-center gap-4  pt-[180px]">
        <div className="  absolute left-[10vw]">
          <p className="font-medium text-[20px] text-[#B36427]">
            ห้องปฏิบัติการ
          </p>
          <p className="font-bold text-[32px] sm:text-[64px]">DESIGN SHOP</p>
        </div>
        <img src="/img/bgGreen.png" className="w-full object-contain" />
      </div>
      <div className="px-[10vw] py-[24px] flex flex-col gap-5">
        <p className=" text-[36px] font-bold w-[47vw] text-[#B36427]">
          ผลิตภัณท์{" "}
        </p>
        <div className="grid lg:grid-cols-5 gap-3">
          {fileDownload.map((item, i) => {
            return (
              <img key={i} src={item.link} className="w-full object-contain rounded-lg drop-shadow-xl border" />
            );
          })}
        </div>
      </div>
      <CustomBottom />
    </div>
  );
}
